<section class="my-account-wrapper">
  <div class="logo hide-on-desktop-down is-flex is-flex-column has-flex-content-center has-flex-align-center">
    <div *ngIf="user.name" class="account-icon is-flex has-flex-content-center has-flex-align-center" style="width: 140px; height: 140px">
      {{ user.getInitials() }}
    </div>
    <div class="account-icon is-flex has-flex-content-center has-flex-align-center" *ngIf="!user.name" style="width: 140px; height: 140px">
      <img width="70px" src="{{'/assets/icons/nav-bar/account_icon_off@2x.svg' | staticp}}" alt="">
    </div>
    <h3 translate="my-account.account-details"></h3>
  </div>

  <div class="my-account-wrapper">
    <h3 class="title hide-on-desktop-up" translate="my-account.my-account"></h3>
    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="accountForm">
      <fieldset class="name" formGroupName="profile">
        <app-input pattern="[a-zA-Z ]*" label="{{'my-account.name' | translate}}" [parentFormGroup]="profileFormGroup" [formControl]="name" inputId="input-account-name"></app-input>
      </fieldset>
      <app-input class="email" label="{{'my-account.email' | translate}}" inputType="email" [formControl]="email" [parentFormGroup]="accountForm"
                 inputId="input-account-email"></app-input>
      <fieldset class="phone" formGroupName="profile">
        <app-input label="{{'my-account.phone' | translate}}" inputType="tel" pattern="^\d{3}-\d{3}-\d{4}$" placeholder="123-456-7890"
                   [parentFormGroup]="profileFormGroup"
                   [errorText]="'errors.invalid-phone-format' | translate"
                   [formControl]="phoneNumber" inputId="input-account-phoneNumber"></app-input>
      </fieldset>
      <div class="toggle-password">
        <a translate="my-account.change-password" (click)="toggleEditPassword = !toggleEditPassword"></a>
        <ng-container *ngIf="toggleEditPassword">
          <fieldset style="margin-top: 10px" formGroupName="password">
            <app-input pattern="^.{6,}$"
                       [class.has-errors]="this.passwordFormGroup.invalid && (this.passwordFormGroup.dirty || this.passwordFormGroup.touched)"
                       label="{{'registration.password' | translate}}" [inputType]="showPasswordText ? 'text': 'password'" [formControl]="password" [parentFormGroup]="passwordFormGroup"
                       inputId="input-account-password">
          <span [class.hidden]="!password.value" class="show-hide form-control-feedback-text" (click)="showPasswordText = !showPasswordText">
            {{ (showPasswordText ? 'form.hide' : 'form.show') | translate }}
          </span>
            </app-input>
            <app-input pattern="^.{6,}$"
                       [class.has-errors]="this.passwordFormGroup.invalid && (this.passwordFormGroup.dirty || this.passwordFormGroup.touched)"
                       label="{{'registration.confirm-password' | translate}}" [inputType]="showConfirmPasswordText ? 'text': 'password'" [formControl]="confirmPassword" [parentFormGroup]="passwordFormGroup"
                       inputId="input-account-confirm-password">
          <span [class.hidden]="!confirmPassword.value" class="show-hide form-control-feedback-text" (click)="showConfirmPasswordText = !showConfirmPasswordText">
            {{ (showConfirmPasswordText ? 'form.hide' : 'form.show') | translate }}
          </span>
              <p class="error-clue" *ngIf="this.passwordFormGroup.invalid && (this.passwordFormGroup.dirty || this.passwordFormGroup.touched)">Passwords don't match</p>
            </app-input>
          </fieldset>
        </ng-container>
      </div>
      <fieldset class="languague" formGroupName="profile">
        <app-select label="{{'my-account.language' | translate}}" [options]="languageOptions" [formControl]="profileFormGroup.get('language')" [parentFormGroup]="profileFormGroup" formControlName="language"></app-select>
        <br/>
      </fieldset>
      <fieldset class="profile" formGroupName="profile">
        <div class="form-group">
          <h4 class="title"> {{ 'my-account.i-m-looking-to' | translate}}:</h4>
          <app-checkbox [inverted]="screenSize >= SCREEN_SIZE.DESKTOP_UP" class="fixed-height is-flex" [text]="'contact.buy' | translate" [formControl]="profileFormGroup.get('buy')" [parentFormGroup]="profileFormGroup"></app-checkbox>
          <app-checkbox [inverted]="screenSize >= SCREEN_SIZE.DESKTOP_UP" class="fixed-height is-flex" [text]="'contact.sell' | translate" [formControl]="profileFormGroup.get('sell')" [parentFormGroup]="profileFormGroup"></app-checkbox>
        </div>
      </fieldset>
      <div class="empty-1"></div>
      <div class="empty-2"></div>
      <div class="empty-3"></div>
      <button type="submit" class="btn btn-primary btn-full-sized" [disabled]="!accountForm.valid" translate="my-account.save-changes"></button>
    </form>
  </div>
</section>
